// extracted by mini-css-extract-plugin
module.exports = {"container":"DropDownContainer_container__1EVOx","placeholderShimmer":"DropDownContainer_placeholderShimmer__1N_pu"};